import { Box, Button, Typography, CircularProgress } from '@mui/material';
import React from 'react'
import { ReactComponent as APPLE_ICON } from '../assets/appleIcon.svg'
import { useLocation } from 'react-router-dom';

const AppleButton = ({ handleSignInWithApple, isLoading = false }) => {
  const location = useLocation();
  return (
    <Box paddingY={1}>
      <Button
        onClick={handleSignInWithApple}
        fullWidth
        variant="contained"
        size="large"
        disabled={isLoading}
        startIcon={
          !isLoading && (
            <APPLE_ICON
              fill="white"
              stroke="white"
              style={{ color:"text.invert", height: "35px" }}
            />
          )
        }
        sx={{
          backgroundColor: "black",
          color:"text.invert",
          '&:hover': {
            backgroundColor: "#333", // Dark gray for hover
            color:"text.invert",
            '& .MuiButton-startIcon svg': {
              fill: "white",
              stroke: "white",
              color:"text.invert"
            }
          },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            color: "text.invert"
          }
        }}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <Typography marginX={2}>
            {location.pathname === "/login" ? "Login with Apple" : "Sign up with Apple"}
          </Typography>
        )}
      </Button>
    </Box>
  );
};

export default AppleButton;